var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import search from '../images/search.svg';
import searchblack from '../images/searchblack.svg';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-right: 40px;\n    flex: 1;\n"], ["\n    margin-right: 40px;\n    flex: 1;\n"])));
var LocationInput = styled.form(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: block;\n    margin-bottom: 25px;\n    position: relative;\n    input[type=\"text\"] {\n        border: ", ";\n        background: ", ";\n        padding: ", ";\n        border-radius: 3px;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 15px;\n        line-height: 20px;\n        color:  ", ";\n        width: 100%;\n        box-sizing: border-box;\n        padding-right: 30px;\n        &:active, &:focus {\n            outline: none;\n        } \n    }\n\n"], ["\n    display: block;\n    margin-bottom: 25px;\n    position: relative;\n    input[type=\"text\"] {\n        border: ", ";\n        background: ", ";\n        padding: ", ";\n        border-radius: 3px;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 15px;\n        line-height: 20px;\n        color:  ", ";\n        width: 100%;\n        box-sizing: border-box;\n        padding-right: 30px;\n        &:active, &:focus {\n            outline: none;\n        } \n    }\n\n"])), function (props) { return props.styleName === 'white' ? '1px solid #30363A' : 'none'; }, function (props) { return props.styleName === 'white' ? 'white' : '#30363A'; }, function (props) { return props.isBottomText ? '6px 16px 22px' : '15px 16px 13px'; }, function (props) { return props.styleName === 'white' ? '#30363A' : '#FEFEFE'; });
var SearchButton = styled.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-block;\n    cursor: pointer;\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    background: url(", ") no-repeat center;\n    background-size: 100%;\n    right: 13px;\n    top: 16px;\n    border: none;\n"], ["\n    display: inline-block;\n    cursor: pointer;\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    background: url(", ") no-repeat center;\n    background-size: 100%;\n    right: 13px;\n    top: 16px;\n    border: none;\n"])), function (props) { return props.styleName === 'white' ? searchblack : search; });
var ResultsWrap = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 343;\n    background: black;\n    width: 100%;\n    top: 100%;\n    background: #30363A;\n    max-height: 150px;\n    overflow: auto;\n"], ["\n    position: absolute;\n    z-index: 343;\n    background: black;\n    width: 100%;\n    top: 100%;\n    background: #30363A;\n    max-height: 150px;\n    overflow: auto;\n"])));
var Title = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-style: normal;\n    font-weight: bold;\n    font-size: 30px;\n    line-height: 40px;\n    letter-spacing: -0.02em;\n    color: ", ";\n    margin-bottom: 40px;\n"], ["\n    font-style: normal;\n    font-weight: bold;\n    font-size: 30px;\n    line-height: 40px;\n    letter-spacing: -0.02em;\n    color: ", ";\n    margin-bottom: 40px;\n"])), function (props) { return props.styleName === 'white' ? '#30363A' : '#FEFEFE'; });
var Name = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    color: #BFBFBF;\n    margin-bottom: 5px;\n"], ["\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    color: #BFBFBF;\n    margin-bottom: 5px;\n"])));
var SItem = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var ButtonsWrap = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: 40px;\n"], ["\n    margin-top: 40px;\n"])));
var Button = styled.button(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: inline-block;\n    width: 160px;\n    border: 1px solid #A4B54D;\n    border-radius: 60px;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: ", ";\n    margin-right: 32px;\n    cursor: pointer;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    box-shadow: none;\n    background: transparent;\n    outline: none;\n\n    &:focus, &:active {\n        outline: none;\n    }\n\n    &:disabled {\n        opacity: 0.7;\n    }\n"], ["\n    display: inline-block;\n    width: 160px;\n    border: 1px solid #A4B54D;\n    border-radius: 60px;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: ", ";\n    margin-right: 32px;\n    cursor: pointer;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    box-shadow: none;\n    background: transparent;\n    outline: none;\n\n    &:focus, &:active {\n        outline: none;\n    }\n\n    &:disabled {\n        opacity: 0.7;\n    }\n"])), function (props) { return props.styleName === 'white' ? '#30363A' : '#FEFEFE'; });
var LocalCoordText = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    position: absolute;\n    width: 300px;\n    bottom: 5px;\n    left: 15px;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 13px;\n    letter-spacing: 0.06em;\n    color: #FEFEFE;\n    opacity: 0.31;\n"], ["\n    position: absolute;\n    width: 300px;\n    bottom: 5px;\n    left: 15px;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 13px;\n    letter-spacing: 0.06em;\n    color: #FEFEFE;\n    opacity: 0.31;\n"])));
function ConvertDDToDMS(D) {
    return [0 | D, 'd ', 0 | (D < 0 ? D = -D : D) % 1 * 60, "' ", 0 | D * 60 % 1 * 60, '"'].join('');
}
export default function SearchResults(props) {
    var onClickRes = props.onClickRes, searchText = props.searchText, setSearchText = props.setSearchText, searchResults = props.searchResults, setSearchResults = props.setSearchResults, searchClick = props.searchClick, isResOpen = props.isResOpen, name1 = props.name1, setName = props.setName, coorText = props.coorText, onDoneClick = props.onDoneClick, onCancelClick = props.onCancelClick, toggleResOpen = props.toggleResOpen, setTest = props.setTest, styleName = props.styleName;
    console.log(styleName);
    var _a = useState(''), convertedCoords = _a[0], setConvertedCords = _a[1];
    var ref2 = useRef(null);
    var handleClickOutside = function (event) {
        if (ref2.current && !ref2.current.contains(event.target)) {
            toggleResOpen(false);
            setTest(false);
        }
    };
    useEffect(function () {
        if (coorText.length > 0) {
            var splittedCoordinates = coorText.split(' ').map(Number);
            var splittedCoordinatesConv = splittedCoordinates.map(function (item) { return ConvertDDToDMS(item); });
            setConvertedCords(splittedCoordinatesConv.join(' '));
        }
        if (coorText.length === 0) {
            setConvertedCords('');
        }
    }, [coorText]);
    useEffect(function () {
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(Wrap, null,
            React.createElement(Title, { styleName: styleName }, "Choosing a place:"),
            React.createElement(SItem, null,
                React.createElement(Name, null, "Location"),
                React.createElement(LocationInput, { styleName: styleName, isBottomText: coorText === '' ? false : true },
                    React.createElement("input", { type: "text", value: searchText, onChange: function (e) { return setSearchText(e.target.value); }, placeholder: "Search for coordinates or adress\u2026" }),
                    React.createElement(LocalCoordText, null, convertedCoords),
                    React.createElement(SearchButton, { type: "submit", value: "", onSubmit: function (e) { return searchClick(e); }, onClick: function (e) { return searchClick(e); }, styleName: styleName })),
                React.createElement(ResultsWrap, { ref: ref2 }, searchResults == null || isResOpen === false ?
                    '' :
                    searchResults)),
            React.createElement(SItem, null,
                React.createElement(Name, null, "Place Name"),
                React.createElement(LocationInput, { styleName: styleName, isBottomText: false },
                    React.createElement("input", { type: "text", value: name1, onChange: function (e) { return setName(e.target.value); }, placeholder: "Type Location Name..." }))),
            React.createElement(ButtonsWrap, null,
                React.createElement(Button, { onClick: function () { return onDoneClick(coorText, name1, ''); }, disabled: (name1 === '' || searchText === '') ? true : false, styleName: styleName }, "Done"),
                React.createElement(Button, { styleName: styleName, onClick: function () { return onCancelClick(); } }, "Cancel"))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
/*
const Wrap = styled.div`
    margin-right: 40px;
    flex: 1;
`

const SearchInput = styled.form`
    display: block;
    margin-bottom: 25px;
    position: relative;
    input[type="text"] {
        border: none;
        border-bottom: 1px solid #FEFEFE;
        font-family: 'Inter';
        font-style: normal;
        font-weight: bold;
        font-size: 30px;
        line-height: 40px;
        letter-spacing: -0.02em;
        color: #FEFEFE;
        padding-bottom: 14px;
        background: transparent;
        width: 100%;
        box-sizing: border-box;
        padding-right: 30px;
        &:active, &:focus {
            outline: none;
        }
    }

`

const SearchButton = styled.input`
    display: inline-block;
    cursor: pointer;
    position: absolute;
    width: 24px;
    height: 24px;
    background: url(${search}) no-repeat center;
    right: 0px;
    top: 13px;
    border: none;
`

const ResultsWrap = styled.div`

`


export default function SearchResults(props) {

    const { onClickRes, lang } = props;

    const [searchText, setSearchText] = useState('')
    const [searchResults, setSearchResults] = useState(null)


    const searchClick = (e) => {
        e.preventDefault();
        fetch(`https://geocode-maps.yandex.ru/1.x/?apikey=acaa4a74-9f27-4305-be8d-b8fbb8e7e2e2&geocode=${searchText}&lang=${lang ? lang : 'ru_RU'}&format=json`)
        .then((response) => {
            return response.json();
          })
        .then((data) => {

            if (data.error) return;

            const coll = data.response.GeoObjectCollection.featureMember;

            if (coll.length > 0) {
                const collSorted = coll.map((item, i) => {
                    return  <ResItem
                                key={i}
                                isNoResult={false}
                                name={item.GeoObject.name}
                                description={item.GeoObject.description}
                                coordinates={item.GeoObject.Point.pos}
                                onClickRes={onClickRes}
                            />
                });
                setSearchResults(collSorted);
                return;
            }
            setSearchResults(null)
            return;
        });
    }

    return <>
        <Wrap>
            <SearchInput>
                <input
                    type="text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Введите текст"
                />
                <SearchButton type="submit" value="" onSubmit={(e) => searchClick(e)} onClick={(e) => searchClick(e)}/>
            </SearchInput>
            <ResultsWrap>
                {searchResults == null ?
                    <ResItem isNoResult={true} /> :
                    searchResults
                }
            </ResultsWrap>
        </Wrap>
    </>
}

*/
//# sourceMappingURL=searchresults.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import search from '../images/search.svg';
import searchblack from '../images/searchblack.svg';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-right: 40px;\n    flex: 1;\n"], ["\n    margin-right: 40px;\n    flex: 1;\n"])));
var LocationInput = styled.form(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: block;\n    margin-bottom: 25px;\n    position: relative;\n    input[type=\"text\"] {\n        border: ", ";\n        background: ", ";\n        padding: ", ";\n        border-radius: 3px;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 15px;\n        line-height: 20px;\n        color:  ", ";\n        width: 100%;\n        box-sizing: border-box;\n        padding-right: 30px;\n        &:active, &:focus {\n            outline: none;\n        } \n    }\n\n"], ["\n    display: block;\n    margin-bottom: 25px;\n    position: relative;\n    input[type=\"text\"] {\n        border: ", ";\n        background: ", ";\n        padding: ", ";\n        border-radius: 3px;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 15px;\n        line-height: 20px;\n        color:  ", ";\n        width: 100%;\n        box-sizing: border-box;\n        padding-right: 30px;\n        &:active, &:focus {\n            outline: none;\n        } \n    }\n\n"])), function (props) { return props.styleName === 'white' ? '1px solid #30363A' : 'none'; }, function (props) { return props.styleName === 'white' ? 'white' : '#30363A'; }, function (props) { return props.isBottomText ? '6px 16px 22px' : '15px 16px 13px'; }, function (props) { return props.styleName === 'white' ? '#30363A' : '#FEFEFE'; });
var SearchButton = styled.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-block;\n    cursor: pointer;\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    background: url(", ") no-repeat center;\n    background-size: 100%;\n    right: 13px;\n    top: 16px;\n    border: none;\n"], ["\n    display: inline-block;\n    cursor: pointer;\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    background: url(", ") no-repeat center;\n    background-size: 100%;\n    right: 13px;\n    top: 16px;\n    border: none;\n"])), function (props) { return props.styleName === 'white' ? searchblack : search; });
var ResultsWrap = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 343;\n    background: black;\n    width: 100%;\n    top: 100%;\n    background: #30363A;\n    max-height: 150px;\n    overflow: auto;\n"], ["\n    position: absolute;\n    z-index: 343;\n    background: black;\n    width: 100%;\n    top: 100%;\n    background: #30363A;\n    max-height: 150px;\n    overflow: auto;\n"])));
var Title = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-style: normal;\n    font-weight: bold;\n    font-size: 30px;\n    line-height: 40px;\n    letter-spacing: -0.02em;\n    color: ", ";\n    margin-bottom: 40px;\n"], ["\n    font-style: normal;\n    font-weight: bold;\n    font-size: 30px;\n    line-height: 40px;\n    letter-spacing: -0.02em;\n    color: ", ";\n    margin-bottom: 40px;\n"])), function (props) { return props.styleName === 'white' ? '#30363A' : '#FEFEFE'; });
var Name = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    color: #BFBFBF;\n    margin-bottom: 5px;\n"], ["\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    color: #BFBFBF;\n    margin-bottom: 5px;\n"])));
var SItem = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var ButtonsWrap = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: 40px;\n"], ["\n    margin-top: 40px;\n"])));
var Button = styled.button(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: inline-block;\n    width: 160px;\n    border: 1px solid #A4B54D;\n    border-radius: 60px;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: ", ";\n    margin-right: 32px;\n    cursor: pointer;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    box-shadow: none;\n    background: transparent;\n    outline: none;\n\n    &:focus, &:active {\n        outline: none;\n    }\n\n    &:disabled {\n        opacity: 0.7;\n    }\n"], ["\n    display: inline-block;\n    width: 160px;\n    border: 1px solid #A4B54D;\n    border-radius: 60px;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: ", ";\n    margin-right: 32px;\n    cursor: pointer;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    box-shadow: none;\n    background: transparent;\n    outline: none;\n\n    &:focus, &:active {\n        outline: none;\n    }\n\n    &:disabled {\n        opacity: 0.7;\n    }\n"])), function (props) { return props.styleName === 'white' ? '#30363A' : '#FEFEFE'; });
var LocalCoordText = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    position: absolute;\n    width: 300px;\n    bottom: 5px;\n    left: 15px;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 13px;\n    letter-spacing: 0.06em;\n    color: #FEFEFE;\n    opacity: 0.31;\n"], ["\n    position: absolute;\n    width: 300px;\n    bottom: 5px;\n    left: 15px;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 13px;\n    letter-spacing: 0.06em;\n    color: #FEFEFE;\n    opacity: 0.31;\n"])));
function ConvertDDToDMS(D) {
    return [0 | D, 'd ', 0 | (D < 0 ? D = -D : D) % 1 * 60, "' ", 0 | D * 60 % 1 * 60, '"'].join('');
}
export default function SearchResults(props) {
    var onClickRes = props.onClickRes, searchText = props.searchText, setSearchText = props.setSearchText, searchResults = props.searchResults, setSearchResults = props.setSearchResults, searchClick = props.searchClick, isResOpen = props.isResOpen, name1 = props.name1, setName = props.setName, coorText = props.coorText, onDoneClick = props.onDoneClick, onCancelClick = props.onCancelClick, toggleResOpen = props.toggleResOpen, setTest = props.setTest, styleName = props.styleName;
    console.log(styleName);
    var _a = useState(''), convertedCoords = _a[0], setConvertedCords = _a[1];
    var ref2 = useRef(null);
    var handleClickOutside = function (event) {
        if (ref2.current && !ref2.current.contains(event.target)) {
            toggleResOpen(false);
            setTest(false);
        }
    };
    useEffect(function () {
        if (coorText.length > 0) {
            var splittedCoordinates = coorText.split(' ').map(Number);
            var splittedCoordinatesConv = splittedCoordinates.map(function (item) { return ConvertDDToDMS(item); });
            setConvertedCords(splittedCoordinatesConv.join(' '));
        }
        if (coorText.length === 0) {
            setConvertedCords('');
        }
    }, [coorText]);
    useEffect(function () {
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(Wrap, null,
            React.createElement(Title, { styleName: styleName }, "Choosing a place:"),
            React.createElement(SItem, null,
                React.createElement(Name, null, "Location"),
                React.createElement(LocationInput, { styleName: styleName, isBottomText: coorText === '' ? false : true },
                    React.createElement("input", { type: "text", value: searchText, onChange: function (e) { return setSearchText(e.target.value); }, placeholder: "Search for coordinates or adress\u2026" }),
                    React.createElement(LocalCoordText, null, convertedCoords),
                    React.createElement(SearchButton, { type: "submit", value: "", onSubmit: function (e) { return searchClick(e); }, onClick: function (e) { return searchClick(e); }, styleName: styleName })),
                React.createElement(ResultsWrap, { ref: ref2 }, searchResults == null || isResOpen === false ?
                    '' :
                    searchResults)),
            React.createElement(SItem, null,
                React.createElement(Name, null, "Place Name"),
                React.createElement(LocationInput, { styleName: styleName, isBottomText: false },
                    React.createElement("input", { type: "text", value: name1, onChange: function (e) { return setName(e.target.value); }, placeholder: "Type Location Name..." }))),
            React.createElement(ButtonsWrap, null,
                React.createElement(Button, { onClick: function () { return onDoneClick(coorText, name1, ''); }, disabled: (name1 === '' || searchText === '') ? true : false, styleName: styleName }, "Done"),
                React.createElement(Button, { styleName: styleName, onClick: function () { return onCancelClick(); } }, "Cancel"))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
/*
const Wrap = styled.div`
    margin-right: 40px;
    flex: 1;
`

const SearchInput = styled.form`
    display: block;
    margin-bottom: 25px;
    position: relative;
    input[type="text"] {
        border: none;
        border-bottom: 1px solid #FEFEFE;
        font-family: 'Inter';
        font-style: normal;
        font-weight: bold;
        font-size: 30px;
        line-height: 40px;
        letter-spacing: -0.02em;
        color: #FEFEFE;
        padding-bottom: 14px;
        background: transparent;
        width: 100%;
        box-sizing: border-box;
        padding-right: 30px;
        &:active, &:focus {
            outline: none;
        }
    }

`

const SearchButton = styled.input`
    display: inline-block;
    cursor: pointer;
    position: absolute;
    width: 24px;
    height: 24px;
    background: url(${search}) no-repeat center;
    right: 0px;
    top: 13px;
    border: none;
`

const ResultsWrap = styled.div`

`


export default function SearchResults(props) {

    const { onClickRes, lang } = props;

    const [searchText, setSearchText] = useState('')
    const [searchResults, setSearchResults] = useState(null)


    const searchClick = (e) => {
        e.preventDefault();
        fetch(`https://geocode-maps.yandex.ru/1.x/?apikey=acaa4a74-9f27-4305-be8d-b8fbb8e7e2e2&geocode=${searchText}&lang=${lang ? lang : 'ru_RU'}&format=json`)
        .then((response) => {
            return response.json();
          })
        .then((data) => {

            if (data.error) return;

            const coll = data.response.GeoObjectCollection.featureMember;

            if (coll.length > 0) {
                const collSorted = coll.map((item, i) => {
                    return  <ResItem
                                key={i}
                                isNoResult={false}
                                name={item.GeoObject.name}
                                description={item.GeoObject.description}
                                coordinates={item.GeoObject.Point.pos}
                                onClickRes={onClickRes}
                            />
                });
                setSearchResults(collSorted);
                return;
            }
            setSearchResults(null)
            return;
        });
    }

    return <>
        <Wrap>
            <SearchInput>
                <input
                    type="text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Введите текст"
                />
                <SearchButton type="submit" value="" onSubmit={(e) => searchClick(e)} onClick={(e) => searchClick(e)}/>
            </SearchInput>
            <ResultsWrap>
                {searchResults == null ?
                    <ResItem isNoResult={true} /> :
                    searchResults
                }
            </ResultsWrap>
        </Wrap>
    </>
}

*/
//# sourceMappingURL=searchresults.js.map